import Vuex from "vuex";
import Vue from "vue";

import commentAction from '../comments/store/actions';
import commentGetters from '../comments/store/getters';
import commentState from '../comments/store/state.js';
import commentMutations from '../comments/store/mutations';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import {
  actions as searchActions,
  getters as searchGetters,
  mutations as searchMutations,
  state as searchState
} from "../searcher/store/state";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userId: null,
    userType: null,
    status: null,
    statusText: null,
    isPartner: null,
    avatarUrl: null,
    nick: null,
    loginUrl: null,
    partnerUrl: null,
    redirectUrl: null,
    profileUrl: null,
    increaseQuotaUrl: null,
    registerUrl: null,
    tarjetaCaducada: null,
    periodoGracia: null,
    carrito: null,
    valuations: 0,
    ...commentState,
    ...searchState,
  },
  getters: {
    ...getters,
    ...commentGetters,
    ...searchGetters,
  },
  actions: {
    ...actions,
    ...commentAction,
    ...searchActions
  },
  mutations: {
    ...mutations,
    ...commentMutations,
    ...searchMutations
  }
});

const initStore = () => {
  store.dispatch('initApp');
};

export { initStore };

export default store;
